export default __webpack_public_path__ + "static/media/Github-desktop.d30db950.svg";